module.exports = __webpack_public_path__ + "img/wordcloud-francesco-casillo.4543a303.png";